import { render, staticRenderFns } from "./addDataPrivilegeUnit.vue?vue&type=template&id=7792140a&scoped=true"
import script from "./addDataPrivilegeUnit.vue?vue&type=script&lang=js"
export * from "./addDataPrivilegeUnit.vue?vue&type=script&lang=js"
import style0 from "./addDataPrivilegeUnit.vue?vue&type=style&index=0&id=7792140a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7792140a",
  null
  
)

export default component.exports